"use client"

import { useState, useEffect } from "react"
import { usePathname } from "next/navigation"
import { WhatsApp } from "./ui/whatsapp"

export function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false)
  const pathname = usePathname()

  // Hide WhatsApp button in admin routes
  const isAdminRoute = pathname.startsWith("/admin")

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  // Don't render the button if it's an admin route
  if (isAdminRoute) {
    return null
  }

  return (
    <a
      href="https://wa.me/5493465650191?text=Hola,%20estoy%20interesado%20en%20un%20alquiler%20temporal"
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 bg-white text-white rounded-full p-3 shadow-lg transition-all duration-300 hover:scale-110 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      aria-label="Contactar por WhatsApp"
    >
      <WhatsApp />
    </a>
  )
}

